/** This is an automatically generated class by FairyGUI. Please do not modify it. **/
export default class UI_SideGames extends fgui.GComponent {
    constructor() {
        super();
    }
    static createInstance() {
        return (fgui.UIPackage.createObject("LTGame", "SideGames"));
    }
    onConstruct() {
        this.m_show = this.getControllerAt(0);
        this.m_ads = (this.getChildAt(1));
        this.m_t0 = this.getTransitionAt(0);
    }
}
UI_SideGames.URL = "ui://75kiu87kii3nhl";
